import { Flex } from "@chakra-ui/layout";
import { useMemo } from "react";
import { HistoricoCobrancaItemResponse } from "core/features/cobranca/typings/index";
import moment from "moment";

function useHistoricoCobrancaColumns() {
  return useMemo(() => {
    return [
      {
        title: "Data",
        width: "350px",
        render: (original: HistoricoCobrancaItemResponse) => (
          <Flex>{moment(original.data).format("DD/MM/YYYY")}</Flex>
        ),
      },
      {
        title: "Condômino",
        width: "350px",
        render: (original: HistoricoCobrancaItemResponse) => (
          <Flex>{original.pessoaResponsavel.nome}</Flex>
        ),
      },
      {
        title: "Resultado",
        width: "350px",
        render: (original: HistoricoCobrancaItemResponse) => (
          <Flex>{original.resultadoCobranca.nome}</Flex>
        ),
      },
      {
        title: "Responsável pelo contato",
        width: "350px",
        render: (original: HistoricoCobrancaItemResponse) => (
          <Flex>{original.pessoaUsuarioOperador.nome}</Flex>
        ),
      },
    ];
  }, []);
}

export default useHistoricoCobrancaColumns;
